




























import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import Cookie from 'js-cookie'
import { LangOption } from '@/config/langulage-config'

@Component
export default class SwitchLanguageComponent extends Vue {
    name = 'switch-language'
    @Prop()
    visible!: boolean

    @Emit('confirm')
    onConfirm() {
        return this.lan
    }

    @Emit('cancel')
    onCancel() {
        return true
    }

    @Emit('before-close')
    beforeClose() {
        return true
    }

    get language() {
        // return this.$store.getters.language
        return Cookie.get('language') || 'zh'
    }

    langOption = LangOption

    lan = this.language

    @Watch('visible')
    visibleChange() {
        this.lan = this.language
    }
}
